import React from "react";
import {
	Card,
	CardHeader,
	CardBody,
	Form,
	FormGroup,
	Label,
	Input,
	Button,
	Col,
	Row,
} from "reactstrap";
import _ from "lodash";
import ReactSelect from 'react-select';
import DatePicker from "react-datepicker";
import { queryHandler } from "utils/queryHandler";

const SearchForm = props => {
	let { 
		searchParams, 
		onChangeHOCState, 
		getListAPI, 
		defaultSearchParams, 
		defaultQuery 
	} = props

	const onHandleSearch = async () => {
		onChangeHOCState("pageIndex", 1);
		let tempQuery = await queryHandler(searchParams);
		getListAPI({
			page: 1,
			is_paginated: true,
			filter: tempQuery
		});
	}


	const handleKeyPress = (e) => {
		if (e.key === "Enter") {
			onHandleSearch()
		}
	};

	return (
		<>
			<Card className="main-card mb-3">
				<CardHeader style={{ textTransform: "capital" }}>Search</CardHeader>
				<CardBody>
					<Form onSubmit={(e) => e.preventDefault()}>
						<Row>
							{searchParams.map((item, index) => {
								return (
									<Col key={index} md={item.col || 12} xs={12}>
										{
											(item.type !== 'checkbox' && item.type !== 'radio') && (
												<FormGroup key={item.value}>
													<Label>{item.label}</Label>
													{item.type === "select" && (
														<Input
															type={"select"}
															value={item.param}
															onKeyPress={handleKeyPress}
															onChange={(e) => {
																let tmp = _.cloneDeep(searchParams);
																tmp[index]["param"] = e.target.value;
																onChangeHOCState("searchParams", tmp);
															}}>
															<option></option>
															{item.options.map((data) => (
																<option key={data.id} value={data.id}>
																	{data.name}
																</option>
															))}
														</Input>
													)}

													{item.type === "multi-select" && (
														<ReactSelect
															options={item.options}
															onChange={val => {
																let tmp = _.cloneDeep(searchParams);
																tmp[index]["param"] = val;
																onChangeHOCState("searchParams", tmp);
															}}
															isMulti
															value={item.param}
														/>
													)}

													{!item.type && (
														<Input
															type={"text"}
															value={item.param}
															onKeyPress={handleKeyPress}
															onChange={(e) => {
																let tmp = _.cloneDeep(searchParams);
																tmp[index]["param"] = e.target.value;
																onChangeHOCState("searchParams", tmp);
															}}
														/>
													)}
													{item.type === "date" && (
														<DatePicker
															dateFormat="dd-MM-yyyy"
															showYearDropdown
															onKeyPress={handleKeyPress}
															selected={
																item.param === null ? null : new Date(item.param)
															}
															className="form-control"
															onChange={(val) => {
																let tmp = _.cloneDeep(searchParams);
																tmp[index]["param"] = val;
																onChangeHOCState("searchParams", tmp);
															}}
														/>
													)}
												</FormGroup>
											)
										}
										{item.type === "radio" && (
											<div className="d-flex flex-wrap" style={{ gap: 20 }}>
												{
													item.options.map(optionChild => (
														<FormGroup check>
															<Input
																className="mr-2"
																type={'radio'}
																onKeyPress={handleKeyPress}
																checked={item.param === optionChild.id}
																onChange={e => {
																	let tmp = _.cloneDeep(searchParams);
																	tmp[index]["param"] = optionChild.id;
																	onChangeHOCState("searchParams", tmp);
																}}
															/>
															<Label check>
																{optionChild.name}
															</Label>
														</FormGroup>
													))
												}
											</div>
										)}
										{
											item.type === 'checkbox' && (
												<div className="d-flex" style={{ gap: 20 }}>
													{
														item.options.map(optionChild => (
															<FormGroup check>
																<Input
																	type={"checkbox"}
																	checked={item.param.indexOf(optionChild.id) > -1}
																	check
																	onKeyPress={handleKeyPress}
																	onChange={(e) => {
																		let tmp = _.cloneDeep(searchParams);
																		let tempIndex = _.findIndex(tmp[index].param, val => val === optionChild.id)

																		if (tempIndex < 0) {
																			tmp[index].param = [
																				...tmp[index].param,
																				optionChild.id
																			]
																		} else {
																			tmp[index].param.splice(tempIndex, 1)
																		}

																		onChangeHOCState("searchParams", tmp);
																	}}>
																	<option></option>
																	{item.options.map((data) => (
																		<option key={data.id} value={data.id}>
																			{data.name}
																		</option>
																	))}
																</Input>
																<Label check>
																	{optionChild.name}
																</Label>
															</FormGroup>
														))
													}
												</div>
											)
										}
									</Col>
								);
							})}
						</Row>
						<div className="d-flex">
							<Button
								color="primary"
								style={{ marginLeft: "auto" }}
								onClick={async () => onHandleSearch()}
								disabled={ props.subscribedPackage === false } 
							>
								Search
							</Button>
							<Button
								color="danger"
								style={{ marginLeft: "10px" }}
								disabled={ props.subscribedPackage === false } 
								onClick={async () => {
									let tmp = [];
									let tmpSearchParams = _.cloneDeep(searchParams);
									tmpSearchParams.map((item) => {
										tmp.push({
											...item,
											param: item.type === "date" ? item.defaultVal : "",
										});
									});
									onChangeHOCState("searchParams", defaultSearchParams ? defaultSearchParams : tmp);
									onChangeHOCState("pageIndex", 1);
									getListAPI(defaultQuery ? defaultQuery : {
										page: 1,
										is_paginated: true
									});
								}}>
								Reset
							</Button>
						</div>
					</Form>
				</CardBody>
			</Card>
		</>
	);
};

export default SearchForm;
